import { render, staticRenderFns } from "./BaseCounter.vue?vue&type=template&id=0ac6bd7a&scoped=true&"
import script from "./BaseCounter.vue?vue&type=script&lang=js&"
export * from "./BaseCounter.vue?vue&type=script&lang=js&"
import style0 from "./BaseCounter.vue?vue&type=style&index=0&id=0ac6bd7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac6bd7a",
  null
  
)

export default component.exports